import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getMyScorm, launchScorm } from "../services/ScormService";

const STATUS_STYLE = {
  assigned: { label: "Not started", bg: "#e9ecef", color: "#495057" },
  "in-progress": { label: "In progress", bg: "#fff3cd", color: "#856404" },
  completed: { label: "Completed", bg: "#d4edda", color: "#155724" },
};

/**
 * "My SCORM Courses" — lists SCORM packages assigned to the learner. Launching
 * one opens the backend-hosted player in a new tab. Purely additive.
 */
export const MyScorm = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem("userName");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setItems(await getMyScorm());
      setLoading(false);
    })();
  }, []);

  const isOverdue = (item) =>
    item.dueDate &&
    item.status !== "completed" &&
    new Date(item.dueDate) < new Date();

  return (
    <div style={{ padding: "30px 50px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button
            onClick={() => navigate("/dashboard")}
            style={{
              display: "flex",
              alignItems: "center",
              background: "white",
              border: "1px solid lightblue",
              borderRadius: "10px",
              color: "rgb(78, 115, 223)",
              padding: "8px 12px",
              cursor: "pointer",
            }}
          >
            <ArrowBackIcon fontSize="small" /> Back
          </button>
          <h2 style={{ margin: 0 }}>My SCORM Courses</h2>
        </div>
        <span style={{ color: "grey" }}>{userName}</span>
      </div>

      {loading && <p>Loading your courses…</p>}

      {!loading && items.length === 0 && (
        <div
          style={{
            padding: "40px",
            textAlign: "center",
            color: "grey",
            background: "#f8f9fa",
            borderRadius: "12px",
          }}
        >
          No SCORM courses have been assigned to you yet.
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
          gap: "20px",
        }}
      >
        {items.map((item) => {
          const status = STATUS_STYLE[item.status] || STATUS_STYLE.assigned;
          return (
            <div
              key={item._id}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "14px",
                padding: "18px",
                background: "white",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: "12px", background: "#eef2ff", color: "#4e73df", padding: "3px 10px", borderRadius: "12px" }}>
                  SCORM {item.scormVersion}
                </span>
                <span style={{ fontSize: "12px", background: status.bg, color: status.color, padding: "3px 10px", borderRadius: "12px" }}>
                  {status.label}
                  {item.scoreRaw != null ? ` · ${item.scoreRaw}` : ""}
                </span>
              </div>

              <h3 style={{ margin: "4px 0", fontWeight: 600 }}>{item.title}</h3>
              {item.description && (
                <p style={{ margin: 0, color: "grey", fontSize: "13px" }}>{item.description}</p>
              )}

              {item.dueDate && (
                <p
                  style={{
                    margin: 0,
                    fontSize: "13px",
                    color: isOverdue(item) ? "#c0392b" : "grey",
                    fontWeight: isOverdue(item) ? 600 : 400,
                  }}
                >
                  Due {new Date(item.dueDate).toLocaleDateString()}
                  {isOverdue(item) ? " — overdue" : ""}
                </p>
              )}

              <button
                onClick={() => launchScorm(item.scormId)}
                style={{
                  marginTop: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  background: "rgb(78, 115, 223)",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <OpenInNewIcon fontSize="small" />
                {item.status === "completed" ? "Review" : item.status === "in-progress" ? "Resume" : "Launch"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
